import { useMutation } from '@tanstack/react-query';

import { del } from '~lib/api/client';

interface UseWikiSalaryDeleteMutationParams {
  onSuccess: () => void;
  onError?: (err: any) => void;
}

interface MutationParams {
  wikiId: number;
}

export default function useWikiSalaryDeleteMutation() {
  return useMutation(({ wikiId }: MutationParams) => del(`/api/hq/wiki/${wikiId}`, {}));
}
